import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SimpleEntityBackendService } from '../../../../../../../shared/services/searchable-entity/simple-entity/simple-entity-backend.service';
import { CoreServiceRegistry } from '../../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../../shared/shared-service-registry';
import { FileUtilityService } from '../../../../../../../shared/services/file-utility.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class PacketPopupBackendService extends SimpleEntityBackendService {

  private fileUtilityService: FileUtilityService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
    this.fileUtilityService = sharedServiceRegistry.fileUtilityService;
  }

  public uploadFile(file: File, masterWorkOrder, worOrderName, tableId: any, screenType: any) {
    // LFWM-3191- passing screenType and tableId in the request.
    return this.sharedServiceRegistry.fileUtilityService.uploadFile(file,
      'api/inventory/womanagement/file/upload/' + masterWorkOrder + '/' + worOrderName + '/' + tableId + '/' + screenType);
  }

  public downloadFile(filePath) {
    return this.fileUtilityService.downloadFile(filePath).subscribe((file) => {
      const fileName = filePath.split('\\').pop().split('/').pop();
      this.fileUtilityService.saveFileLocally(file, fileName);
    });
  }

  public saveUploadedPacket(request) {
    const response$ = this.http$.post('api/inventory/womanagement/packet/' , JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public generatePacket() {
    const response$ = this.http$.get('api/inbound/document/WORPACKETSTD/number')
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public deleteImportedPackets(request: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/inventory/womanagement/', options)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/work-order-management/configuration/work-order-routing/service/packet/packet-popup-backend.service.ts